import { useRef, useState } from 'react';

import { IconButton } from '@mui/material';

import AppsIcon from '@mui/icons-material/Apps';
import { MenuItem } from '../Menu.types';
import { Popup } from '../Popup';
import { AlignTypes } from 'models/commonTypes';

export type PopupMenuProps = {
  items: Array<MenuItem>;
};

export const PopupMenu = ({ items }: PopupMenuProps) => {
  const [open, setOpen] = useState(false);
  const [preventClose, setPreventClose] = useState(false);
  const anchorRef = useRef(null);

  const handleIconClick = () => {
    if (!items) {
      return;
    }

    setOpen(!open);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const closePopup = () => {
    setPreventClose(false);
    setOpen(false);
  };

  return (
    <>
      <IconButton data-testid="popup-menu" onClick={handleIconClick} ref={anchorRef}>
        <AppsIcon />
      </IconButton>
      {items.length > 0 ? (
        <Popup
          anchorRef={anchorRef}
          closeParentPopup={closePopup}
          handleClose={handleClose}
          items={items}
          open={open}
          placement={AlignTypes.RIGHT}
          preventParentClose={preventClose}
          setPreventParentClose={setPreventClose}
        />
      ) : null}
    </>
  );
};
